<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :actions="actions"
      ref="grid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :selectionEnabled="false"
    ></dx-grid>

    <v-dialog
      v-model="updateDialog"
      max-width="70%"
      style="background-color: brown;"
    >
      <v-card class="px-3 pb-3">
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            color="green"
            style="background-color: rgba(0,0,0,0.3);"
            @click="updateDialog = false"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-layout>
        <dedication-sale-view
          :style="{ padding: '0 !important' }"
          :key="dialogKey"
          :initial-data="{ dedicationSale }"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DedicationSaleView from "./DedicationSaleView.vue";

export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DedicationSaleView,
  },
  data: () => ({
    title: "Dedication Sales",
    url: "dedications",
    actions: [],
    processing: false,

    items: [],
    availItems: [],
    donors: [],
    search: "",
    loadingDonors: false,
    loadingItems: false,
    searchTimeout: null,
    dialogKey: 0,
    dedicationSale: null,
    updateDialog: false,
    columns: [
      {
        label: "Sale ID",
        field: "saleID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-120",
      },
      {
        label: "Person ID",
        field: "personID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-120",
      },

      {
        label: "Name (EN)",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "Name (HE)",
        field: "nameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200 text-right",
        dir: "rtl",
      },
      {
        label: "Item Name",
        field: "itemName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "זכות",
        field: "itemType",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200 text-right",
        dir: "rtl",
      },
      {
        label: "Is Legacy",
        field: "isLegacy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-100 text-center",
        format: "boolean",
      },
      {
        label: "Dedication Item ID",
        field: "dedicationItemID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-150",
      },
      {
        label: "Offer Price",
        field: "offerPrice",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-120 text-end",
        format: "currency",
      },
      {
        label: "Final Price",
        field: "finalPrice",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-120 text-end",
        format: "currency",
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-130",
      },
      {
        label: "Description",
        field: "saleDescription",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Created On",
        field: "createdOn",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-160",
      },
      {
        label: "Created By",
        field: "createdBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-150",
      },
      {
        label: "Completed On",
        field: "completedOn",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-160",
        format: "date",
      },
      {
        label: "Completed By",
        field: "completedBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-150",
      },
      {
        label: "Parent ID",
        field: "parentId",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-120",
      },
      {
        label: "Wedding Year",
        field: "weddingYear",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-130 text-center",
      },
    ],
  }),
  methods: {
    async onRowClicked(row) {
      this.dedicationSale = { ...row };
      this.updateDialog = true;
      this.dialogKey += 1;
    },
  },
};
</script>
<style scoped></style>
